import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ToastService } from '../../@theme/service/toast.service';
import { AbstractIntervalRequester } from '../service/abstract-interval-requester';
import { CommonBlockService } from '../service/common-block.service';
import { DateHelper } from '../util/date-helper.util';

@Injectable({
  providedIn: 'root',
})
export class LeakedFileCheker extends AbstractIntervalRequester {
  private _source: Subject<boolean> = new Subject<boolean>();
  private _detected: boolean = false;
  private _checkHolding: LeakedFileChekerHolding;

  /**
   * 집중감시 모드 전환 하지 않는 경우 임시 해제
   */
  public set holding(value: boolean) {
    this._checkHolding.holding = value;
    this._checkHolding.expired = this.dateHelper.add('day', 1, new Date());
    localStorage.setItem('leakedFileCheckHolding', JSON.stringify(this._checkHolding));
  }
  public get holding() {
    return this._checkHolding.holding;
  }

  public onDetected: Observable<boolean> = this._source.asObservable();
  public detectedCount: number = 0;

  public set detected(value: boolean) {
    this._detected = value;
    this._source.next(this.detected);
  }

  public get detected(): boolean {
    return this._detected;
  }

  constructor(
    private toast: ToastService,
    private dateHelper: DateHelper,
    private commonBlockService: CommonBlockService,
    private router: Router,
  ) {
    super();
    this._interval = 1000 * 5; // 5초마다
    this._checkHolding = new LeakedFileChekerHolding(JSON.parse(localStorage.getItem('leakedFileCheckHolding')));

    if (this._checkHolding.holding && this._checkHolding.expired) {
      if (this.dateHelper.diff('day', this._checkHolding.expired, new Date()) > 0) {
        this.holding = false;
      }
    }
  }

  start(): boolean {
    console.debug('Start - Document leaked checking... / interval=', this._interval);
    this.holding = false;
    return super.start();
  }

  run() {
    if (!this._timer) return;

    // 현재 페이지가 대시보드-문서유출 맵을 표시하고 있으면 패스
    if (this.router.url.indexOf('pages/dashboard') >= 0 && this.detected) return;

    this.commonBlockService.countByExternalAccess().subscribe((res) => {
      if (res && res.data) {
        this.detectedCount = Number(res.data);
        if (this.detectedCount > 0) {
          if (this.holding) {
            this.detected = true;
          } else {
            this.toast.showToast('danger', '문서유출 발생', `${this.detectedCount}건의 문서유출 이력이 발생 되었습니다.`);
            setTimeout(() => {
              this.detected = true;
              if (!this.holding) this.router.navigate(['pages/dashboard']);
            }, 1000);
          }
        } else if (this.detected) {
          this.detected = false;
        }
      }
    });
  }

  stop() {
    super.stop();
    this._detected = false;
  }
}

export class LeakedFileChekerHolding {
  public holding: boolean;
  public expired: Date;

  constructor(obj?: any) {
    this.holding = obj?.holding || false;
    this.expired = obj?.expired ? new Date(obj.expired) : null;
  }
}
